import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import { EditjobsPage } from './editjobs';

/**
 * Generated class for the JobsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@IonicPage({
  name: 'jobs'
})

@Component({
  selector: 'page-jobs',
  templateUrl: 'jobs.html',
})
export class JobsPage {
  loadingData: boolean = false
  joobs = []
  priv: boolean = false


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public modalCtrl: ModalController, public alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad JobsPage');
    this.loadData()
  }

  loadData() {
    this.loadingData = true
    this.priv = this.gn.getPriv('jobs')
    var _that = this
    this.gn._Post('/api/gn/getJobs', {}, function (_data) {
      _that.joobs = _data
      _that.loadingData = false
    })
  }


  editJoobs(_u) {
    var _that = this
    let modal = this.modalCtrl.create(EditjobsPage, {
      jo: _u, cb: function () {
        _that.loadData()
      }
    });
    modal.present();
  }

  addNewJob() {
    var _that = this
    let modal = this.modalCtrl.create(EditjobsPage, {
      jo: { id: -1 }, cb: function () {
        _that.loadData()
      }
    });
    modal.present();
  }

  deleteJobs(id: number, name: string, idx: number) {
    var _that = this;
    let alert = _that.alertCtrl.create({
      title: _that.dic.l["deletejobs"],
      subTitle: _that.dic.l["areyouwantodellJob"] + ' ' + name,
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            _that.gn.loadWaiting();
            this.gn._Post('/api/gn/delJobs', { id: this.gn.crypt(id) }, function (_data) {
              _that.gn.loaderWaiting.dismiss();
              _that.joobs.splice(idx, 1);
            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/jobs/jobs.ts